import React from 'react';
import PreviewCode from "../PreviewCode/PreviewCode";

const PreviewJSON = ({
  theme = "light",
  data
}) => {
  return React.createElement(PreviewCode, {
    theme: theme,
    language: "json"
  }, data);
};

export default PreviewJSON;